// @flow
import * as React from 'react';

import { BoostContainer, BoostHeader, BoostTimer, DropdownIcon } from './styles';

import generalIcons from '~/core/constants/icons/general-svg';
import { get } from 'lodash/fp';
import { injectIntl } from 'react-intl';
import intervalUpdate from '~/core/decorators/interval-update';
import messages from '~/core/i18n/components/widgets/boost/intl';
import { padNumber } from '~/core/utils/numbers';
import Spinner from '~/components/widgets/spinner/spinner.component';

type Props = {
    controlMode: string,
    duration: 30 | 60 | 120 | 180 | 240 | 300 | 360,
    intl: $npm$ReactIntl$IntlShape,
    selectedTime: number,
    setBoost: (value: number, controlMode: string) => void
};

type State = {
    boostCaptions: Array<string>,
    boostOptions: Array<{ value: number, caption: string }>,
    showDropDown: boolean
};

class Boost extends React.Component<Props, State> {
    state = {
        boostCaptions: [],
        boostOptions: [],
        showDropDown: false
    };

    componentWillMount() {
        const { intl } = this.props;
        const boostOptions = [
            { value: 30, caption: intl.formatMessage(messages.thirtyMinutes) },
            { value: 60, caption: intl.formatMessage(messages.oneHour) },
            { value: 120, caption: intl.formatMessage(messages.twoHours) },
            { value: 180, caption: intl.formatMessage(messages.threeHours) },
            { value: 240, caption: intl.formatMessage(messages.fourHours) },
            { value: 300, caption: intl.formatMessage(messages.fiveHours) },
            { value: 360, caption: intl.formatMessage(messages.sixHours) }
        ];
        const boostCaptions = boostOptions.map(opt => opt.caption);

        this.setState({
            boostCaptions,
            boostOptions
        });
    }

    toggleDropdown = () => this.setState({ showDropDown: !this.state.showDropDown });

    setBoostFromIndex = (index: number) => {
        const { controlMode, setBoost } = this.props;
        const { boostOptions } = this.state;
        const value = get([index, 'value'], boostOptions);

        setBoost(value, controlMode);
    };

    render() {
        const { selectedTime, duration } = this.props;
        const { boostCaptions, boostOptions, showDropDown } = this.state;
        const currentIndex = boostOptions.findIndex(opt => opt.value === selectedTime);
        const hours = Math.floor(duration / 60);
        const minutes = duration % 60;

        return (
            <BoostContainer data-qa="boost-base">
                <BoostHeader data-qa="boost-timer-current" onClick={this.toggleDropdown}>
                    <BoostTimer data-qa="boost-timer">
                        {padNumber(Math.max(hours, 0))}
                        :
                        {padNumber(Math.max(minutes, 0))}
                    </BoostTimer>
                    <DropdownIcon
                        data-qa="boost-timer-toggle"
                        type={showDropDown ? generalIcons.ARROW_UP : generalIcons.ARROW_DOWN}
                    />
                </BoostHeader>
                {showDropDown && (
                    <Spinner
                        bgColor={{ r: 255, g: 255, b: 255 }}
                        color={{ r: 47, g: 68, b: 78 }}
                        currentIndex={currentIndex}
                        data-qa="boost-timer-spinner"
                        font={'Bariol, Arial, sans-serif'}
                        handleChangeIndex={this.setBoostFromIndex}
                        rangeValues={boostCaptions}
                        style={{
                            width: '100%',
                            height: '4rem',
                            fontSize: '2rem',
                            marginBottom: '1rem',
                            outline: 'none'
                        }}
                    />
                )}
            </BoostContainer>
        );
    }
}

export default intervalUpdate(injectIntl(Boost), 1000);



// WEBPACK FOOTER //
// ./src/components/widgets/boost/component.js